import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'value', 'error']
  static values = { url: String }

  async reveal (event) {
    event.preventDefault()
    if (!this.hasUrlValue) return

    const confirmed = window.confirm(
      'Kya delivery person aapke doorstep par pohanch gaya hai? PIN call ya chat par pehle share na karein.'
    )
    if (!confirmed) return

    this.buttonTarget.disabled = true
    this.buttonTarget.textContent = 'PIN loading…'
    this.errorTarget.classList.add('hidden')

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
        },
        cache: 'no-store'
      })
      const data = await response.json()
      if (!response.ok) throw new Error(data.error || 'PIN could not be loaded.')

      this.valueTarget.querySelector('[data-pin-digits]').textContent = data.pin
      this.valueTarget.classList.remove('hidden')
      this.buttonTarget.classList.add('hidden')
    } catch (error) {
      this.errorTarget.textContent = error.message
      this.errorTarget.classList.remove('hidden')
      this.buttonTarget.disabled = false
      this.buttonTarget.textContent = 'Delivery aa gayi - PIN reveal karein'
    }
  }

  disconnect () {
    const digits = this.valueTarget?.querySelector('[data-pin-digits]')
    if (digits) digits.textContent = ''
  }
}
